import { IPaginator } from "common/types";

import { rangeArray } from "./numbers";

export const getPageOptions = (paginator: IPaginator, { extraPages = 3 } = {}) => {
  const totalNumPages = Math.ceil(Math.max(paginator.count, 1) / Math.max(paginator.page_size, 1));
  const totalPages = paginator.max_page
    ? Math.min(paginator.max_page, totalNumPages)
    : totalNumPages;
  const start = paginator.page - extraPages;
  const end = paginator.page + extraPages;
  const overflowMin = Math.max(1 - start, 0);
  const overflowMax = Math.max(end - totalPages, 0);

  const minPage = Math.max(start - overflowMax, 1);
  const maxPage = Math.min(end + overflowMin, totalPages);

  const pages = rangeArray(minPage, maxPage + 1);

  const showFirstPage = minPage > 1;
  const showFirstDots = minPage > 2;
  const showLastPage = maxPage < totalPages;
  const showLastDots = maxPage < totalPages - 1;
  const canPrevious = paginator.page > 1;
  const canNext = Math.max(paginator.page, 1) < totalPages;

  return {
    pages,
    showFirstPage,
    showFirstDots,
    showLastPage,
    showLastDots,
    canPrevious,
    canNext,
    nextPage: paginator.page + 1,
    previousPage: paginator.page - 1,
    firstPage: 1,
    lastPage: totalPages,
    totalPages,
  };
};
